import {addClass, findID, listener, onReady, onResize, removeClass} from "../../../../modules/vegas/js/util";

const position = 400;
const btnId = 'btn-scroll-to-top';

function init () {
	let $layoutScrollToTop = findID(btnId);

	if (!$layoutScrollToTop) {
		let div = document.createElement('div');
		addClass(div, 'to-top');
		div.setAttribute('id', btnId);
		div.innerHTML = '<span><i class="fal fa-chevron-up"></i></span>';

		document.body.append(div);
	}

	setPosition();
}

function setPosition () {
	let $sticky = findID(btnId);

	if (document.documentElement.scrollTop >= position) {
		addClass($sticky, 'is-active')
	} else {
		removeClass($sticky, 'is-active')
	}
}

listener('click', '#' + btnId, function () {
	window.scrollTo(0, 0);
});

onReady(init);
onResize(setPosition);

typeof onTurboRender !== 'undefined' && onTurboRender(init);
